var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Component from "../lib/component";
import html from "./loading.html";
import "./loading.scss";
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "loading", html) || this;
        window.loadingBox = _this;
        return _this;
    }
    MyComponent.prototype.show = function () {
        this.container.classList.remove("hide");
    };
    MyComponent.prototype.hide = function () {
        this.container.classList.add("hide");
    };
    return MyComponent;
}(Component));
export default new MyComponent();
